
<div id="idCounterpartyLimits" class="col-md-12 col-lg-12 col-sm-12 padding0px">
  <div class="row margin0px padding0px div-cl-tabs" id="tabs">
    <dx-tabs class="tabs" #limitTabs id="tablimit"
             [dataSource]="__oLimitTabs"
             [(selectedIndex)]="__iTabIndex"
             (onItemClick)="tab_Selected($event)"
             [scrollByContent]="true"
             [showNavButtons]="true"
             style="width: 99%; "></dx-tabs>
  </div>

  <div id="div-scroll" [ngClass]="{'expanded-div-scroll':__bIsLoadedFromDataSearch}" class="col-lg-12 col-md-12 col-xs-12 dx-tab-content-body">

    <div id="divlimits" [hidden]="__sTabContent != 'General'" class="col-lg-12 col-md-12 col-xs-12 padding0px">

      <div class="row margin0px padding0px">
        <div class="dx-field col-lg-5 col-md-5 col-xs-5 padding0px">
          <dx-check-box id="chkIsFreezed"
                        class="width-30"
                        text="Freeze columns"
                        [(value)]="__bIsFreezed"
                        (onValueChanged)="checkBox_valueChanged($event,'IsFreezed')">
          </dx-check-box>
          <dx-check-box id="chkIsCustomColumn" *ngIf="__bIsCustomColumnsAvailable"
                        class="width-30"
                        text="Custom columns"
                        [(value)]="__bIsIsCustomColumn"
                        (onValueChanged)="checkBox_valueChanged($event,'bIsCustomColumn')">
          </dx-check-box>
        </div>
        <div class="dx-field col-lg-4 col-md-4 col-xs-4 padding0px btn-toggle-switch">
          <span class="span-text">
            Simple View
          </span>
          <div class="dx-field-value" style="width: auto;">
            <dx-switch id="swTimeLineLimit" [value]="__bSwitch"
                       switchedOnText=""
                       switchedOffText=""
                       (onValueChanged)="radioButton_OnValueChanged($event)">
            </dx-switch>
          </div>
          <span class="span-text">
            Timeline View
          </span>
        </div>
        <div class="col-lg-3 col-md-3 col-xs-3">
          <div class="div-add-new" [ngClass]="{'Disabled' : !__bAllowAddLimits}" title="Add new limit">
            <a id="CL_limitAdd_Btn" class="btn-info btn-icon-text"
               (click)="btnAddNew_Click()" [ngClass]="{'Disabled' : !__bAllowAddLimits}">
              <span class="dx-icon dx-icon-plus"></span>
            </a>
            <span class="fontStyle" (click)="btnAddNew_Click()" [ngClass]="{'Disabled' : !__bAllowAddLimits}">Add new limit</span>
          </div>
        </div>
      </div>

      <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
        <div id="divlimitsContainer" [ngClass]="{'divlimitsContainerCollapsed': !__bSideBar,'divlimitsContainer': __bSideBar,'extended-trlCounterpartyLimits':__bIsLoadedFromDataSearch}">
          <dx-tree-list class="dashboard-grid" id="trlCounterpartyLimits" #trlCounterpartyLimits
                        [dataSource]="__oFourEyeManager.__bIsFourEyeEnabled?__oBindDatasource:__oDatasource"
                        [(columns)]="__oGridcolumns"
                        [rootValue]="-1"
                        keyExpr="lCounterpartyLimitId"
                        parentIdExpr="lParentCounterpartyLimitId"
                        [expandedRowKeys]="__iKeys"
                        [allowColumnReordering]="false"
                        [allowColumnResizing]="true"
                        columnResizingMode="widget"
                        [columnMinWidth]="1"
                        [columnAutoWidth]="true"
                        [autoExpandAll]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [showBorders]="true"
                        [rowAlternationEnabled]="false"
                        [hoverStateEnabled]="true"
                        [wordWrapEnabled]="true"
                        [cellHintEnabled]="true"
                        (onRowUpdated)="onRow_Updated($event)"
                        (onRowUpdating)="onRow_Updating($event)"
                        [(selectedRowKeys)]="__oLimitGridSelectedKeys"
                        (onRowPrepared)="onRow_Prepared($event)"
                        (onCellClick)="onCell_Click($event)"
                        (onCellPrepared)="onCell_Prepared($event)"
                        (onEditorPreparing)="datePickerService.onEditorPreparingMethod($event)"
                        (onExporting)="onExporting($event, '__sCounterpartyLimit')">
            <dxo-export [enabled]="false" [allowExportSelectedData]="true"></dxo-export>
            <dxo-editing mode="cell"
                         [allowUpdating]="!__bSideBar"
                         [allowDeleting]="false"
                         [allowAdding]="false">
            </dxo-editing>
            <dxo-load-panel [enabled]="false"></dxo-load-panel>
            <dxo-scrolling showScrollbar="always" mode="standard"></dxo-scrolling>
            <dxo-paging  [pageSize]="__oFourEyeManager.__bIsFourEyeEnabled?__oBindDatasource?.length:__oDatasource?.length"></dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-filter-row [visible]="true"
                            applyFilter="auto"></dxo-filter-row>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <div *dxTemplate="let Info of 'editCellTemplateTextArea'">
              <dx-text-box [(value)]="Info.data.EntityGroupAudit.UserName" [disabled]="true">
              </dx-text-box>
            </div>

            <div *dxTemplate="let Info of 'cellTemplateTextArea'" align="center">
              <div *ngIf="!isFourEyeRow(Info) && Info.data.UserNameFirstLetters" class="min-width-auto amended" (click)="onCellHoverChanged(Info)" [innerHtml]="Info.data.UserNameFirstLetters"></div>
            </div>
            <div *dxTemplate="let Info of 'cellTemplateCustomColumn'" align="center">
              <div *ngIf="!isFourEyeRow(Info) && (Info.data.LimitTypeName !== 'Volume' || (!Info.data.IsBuy && Info.data.LimitTypeName === 'Volume')) && { customColumn: __oLimitCustomProperties[Info.columnIndex-__iColumnCountBeforeAmanded] } as oInfo" [ngSwitch]="oInfo.customColumn.LimitCustomPropertyDataType">
                <span *ngSwitchCase="'Date'">{{getCustomColumnValue(Info.data,oInfo.customColumn) | date: __sPortalDateFormat }}</span>
                <span *ngSwitchCase="'Numeric'">{{getCustomColumnValue(Info.data,oInfo.customColumn) | number }}</span>
                <span *ngSwitchCase="'Money'">{{getCustomColumnValue(Info.data,oInfo.customColumn) | number }}</span>
                <span *ngSwitchDefault>{{getCustomColumnValue(Info.data,oInfo.customColumn)}}</span>
              </div>
            </div>
            <div *dxTemplate="let Info of 'cellTemplateIcon'">
              <div style="display: flex;" *ngIf="!isFourEyeRow(Info)">
                <div class="float-left" style="margin-top: 0.3rem;">
                  <i *ngIf="(Info.data.LimitTypeName !== 'Volume' && Info.data.TradingLimitComment) || ( Info.data.TradingLimitComment && !Info.data.IsBuy && Info.data.LimitTypeName === 'Volume')"
                     id="btncomments" type="button" class="dx-icon-comment commentbuttonstyle" (click)="updateComments(Info)"></i>
                </div>
                <div *ngIf="Info.data.Warnings.length > 0 && (Info.data.TradingCategoryName == 'Headroom' || Info.data.TradingCategoryName == 'Overall'|| Info.data.IsOverall === 1)" class="warningBtnStyle">
                  <i class='glyphicon glyphicon-alert warning' (click)="alert(Info.data,0,'locatecell')">
                    <span style='font-size:16px;color: #f1a100;vertical-align: text-top;padding-left: 2px;'>{{Info.data.Warnings.length}}</span>
                  </i>
                </div>
                <div class="float-left">
                  <i *ngIf="Info.data.LinkedLCPCGMessage" id="btninfo" type="button" class="btn-info-icon-round LCPCGbuttonStyle" [title]="Info.data.LinkedLCPCGMessage"></i>
                </div>
              </div>
            </div>

            <div *dxTemplate="let info of 'titleHeaderTemplate'">
              <p>
                <i id="ttShowMessage" type="button" class="btn-info btn-info-icon-round" (click)="showMessage(Info)" title="The Counterparty you searched for and its Sublimits are displayed by default.">
                </i>
                {{info.column.caption}}
              </p>
            </div>

            <div *dxTemplate="let Info of 'cellTemplateCPComboBox'">
              <dx-select-box [dataSource]="__oCounterParties"
                             displayExpr="TradingCounterpartyName"
                             valueExpr="TradingCounterpartyName"
                             [(value)]="Info.data.TradingCounterpartyName"
                             (onSelectionChanged)="selectbox_onSelectionChanged(Info.data,'lTradingCounterpartyId',$event)"
                             [searchEnabled]="true">
              </dx-select-box>
            </div>

            <div *dxTemplate="let Info of 'cellTemplateOurEntityComboBox'">
              <dx-select-box [dataSource]="__oTradingEntities"
                             displayExpr="TradingEntityName"
                             valueExpr="TradingEntityName"
                             [(value)]="Info.data.TradingEntityName"
                             (onSelectionChanged)="selectbox_onSelectionChanged(Info.data,'lOurEntityId',$event)"
                             [searchEnabled]="true">
              </dx-select-box>
            </div>

            <div *dxTemplate="let Info of 'cellTemplateLimitTypeComboBox'">
              <div *ngIf="Info.data.IsTempLimitAllocated && !isFourEyeRowSubLimitType(Info)" class="col-lg-12 col-sm-12 col-md-12 limitfont-Size-big">
                {{Info.data.SubLimitTypeName}}<br />
              </div>

              <div *ngIf="Info.data.LimitTypeName !== 'Volume' && !isFourEyeRow(Info)" class="col-lg-12 col-sm-12 col-md-12" [ngClass]="{'limitfont-Size-small':Info.data.IsTempLimitAllocated}" style="text-align:left">
                {{Info.data.LimitTypeName}}
              </div>

              <div *ngIf="Info.data.LimitTypeName === 'Volume' && !isFourEyeRow(Info)" class="col-lg-12 col-sm-12 col-md-12" [ngClass]="{'limitfont-Size-small':Info.data.IsTempLimitAllocated}" style="text-align:left">
                <span *ngIf="Info.data.IsBuy">{{Info.data.LimitTypeName}}-Buy</span><span *ngIf="!Info.data.IsBuy">{{Info.data.LimitTypeName}}-Sell</span>
              </div>
            </div>

            <div *dxTemplate="let Info of 'cellTemplateSubLimitTypeComboBox'">
              <dx-select-box [dataSource]="__oSubLimitTypes"
                             displayExpr="SubLimitTypeName"
                             valueExpr="SubLimitTypeName"
                             [(value)]="Info.data.SubLimitTypeName"
                             (onSelectionChanged)="selectbox_onSelectionChanged(Info.data,'lSubLimitTypeId',$event)"
                             [searchEnabled]="true">
              </dx-select-box>
            </div>

            <div *dxTemplate="let Info of 'editcellTemplateCurrencyComboBox'">
              <dx-select-box *ngIf="Info.data.LimitTypeName !== 'Volume'"
                             [dataSource]="__oCurrencies"
                             displayExpr="CurrencyName"
                             valueExpr="CurrencyName"
                             [(value)]="Info.data.CurrencyName"
                             (onSelectionChanged)="selectbox_onSelectionChanged(Info.data,'lLimitValueCurrencyId',$event)"
                             [disabled]="Info.data.IsEditorEnabled"
                             [searchEnabled]="true">
              </dx-select-box>
              <dx-select-box *ngIf="Info.data.LimitTypeName === 'Volume'" [dataSource]="__oUnits"
                             displayExpr="UnitName"
                             valueExpr="UnitName"
                             [(value)]="Info.data.UnitName"
                             (onSelectionChanged)="selectbox_onSelectionChanged(Info.data,'lUnitId',$event)"
                             [disabled]="false"
                             [searchEnabled]="true">
              </dx-select-box>
            </div>

            <div *dxTemplate="let Info of 'cellTemplateCurrencyComboBox'" [ngClass]="{'parent-entity-lock':isEntityRestrictedRow(Info)}">
              <i *ngIf="isEntityRestrictedRow(Info)" class='glyphicon glyphicon-lock entity-lock'></i>
              <div *ngIf="Info.data.LimitTypeName === 'Volume' && !isFourEyeNewLimit(Info)" class="col-lg-12 col-sm-12 col-md-12 padding-left-20" style="text-align:left">
                {{Info.data.UnitName}}
              </div>

              <div *ngIf="Info.data.LimitTypeName !== 'Volume' && !isFourEyeNewLimit(Info)" class="col-lg-12 col-sm-12 col-md-12 padding-left-20" style="text-align:left">
                {{Info.data.CurrencyName}}
              </div>
            </div>

            <div *dxTemplate="let Info of 'editCellTemplateTenorTypeComboBox'">
              <dx-select-box *ngIf="Info.data.IsTempLimitAllocated" [dataSource]="__oTenorTypes"
                             displayExpr="TenorTypeName"
                             valueExpr="TenorTypeName"
                             [(value)]="Info.data.TempLimitTenorTypeName"
                             (onValueChanged)="selectbox_onSelectionChanged(Info.data,'lTempLimitTenorTypeId',$event)"
                             [searchEnabled]="true">
              </dx-select-box>

              <dx-select-box *ngIf="!Info.data.IsTempLimitAllocated" [dataSource]="__oTenorTypes"
                             displayExpr="TenorTypeName"
                             valueExpr="TenorTypeName"
                             [(value)]="Info.data.TenorTypeName"
                             (onValueChanged)="selectbox_onValueChanged(Info.data,'lTenorTypeId',$event)"
                             [disabled]="Info.data.EntityState != 1"
                             [searchEnabled]="true">
              </dx-select-box>

            </div>


            <div *dxTemplate="let Info of 'cellTemplateTenorTypeComboBox'" [ngClass]="{'parent-entity-lock':isEntityRestrictedRow(Info)}">
              <i *ngIf="isEntityRestrictedRow(Info)" class='glyphicon glyphicon-lock entity-lock'></i>
              <div *ngIf="Info.data.IsTempLimitAllocated && !isFourEyeNewLimit(Info)" class="col-lg-12 col-sm-12 col-md-12 limitfont-Size-big padding-left-20">
                {{Info.data.TempLimitTenorTypeName}}
              </div>

              <div class="col-lg-12 col-sm-12 col-md-12 padding-left-20" *ngIf="!isFourEyeNewLimit(Info)" [ngClass]="{'limitfont-Size-small':Info.data.IsTempLimitAllocated}" style="text-align:left">
                {{Info.data.TenorTypeName}}
              </div>
            </div>
            <div *dxTemplate="let Info of 'cellDeleteTemplate'" style="text-align: center;">
              <dx-button *ngIf="isFourEyeRow(Info)" class="float-left min-width-auto" (onClick)="onOpenWorkflowPopup(Info.data)" text="P"></dx-button>
              <dx-drop-down-button *ngIf="!isFourEyeRow(Info) && !Info.data.IsReadonlyAccess && Info.data.IsTradingCounterpartyInstanceSaveAccess" [splitButton]="false"
                                   [useSelectMode]="false"
                                   icon="preferences"
                                   class="btn-multi-function-icon"
                                   [dropDownOptions]="{ width: 200 }"
                                   [items]="__oProfileSettings"
                                   displayExpr="name"
                                   keyExpr="id"
                                   [disabled]="Info.data.FourEyeRequestStatus > 0 || Info.data.FourEyeRequestTempStatus > 0"
                                   (onButtonClick)="onButtonClick(Info)"
                                   (onItemClick)="onItemClick($event,Info)">

              </dx-drop-down-button>
              <i *ngIf="isEntityRestrictedRow(Info)" id="btninfo" type="button" class="btn-info-icon-round LCPCGbuttonStyle" title="You don't have permission to make changes on this row."></i>
            </div>
            <div *dxTemplate="let Info of 'editcellTemplateTradingCategoryComboBox'">
              <dx-select-box *ngIf="Info.data.LimitTypeName !== 'Volume'" [dataSource]="__oTradingCategories"
                             displayExpr="TradingCategoryName"
                             valueExpr="TradingCategoryName"
                             [(value)]="Info.data.TradingCategoryName"
                             (onSelectionChanged)="selectbox_onSelectionChanged(Info.data,'lTradingCategoryId')"
                             [searchEnabled]="true">
              </dx-select-box>
              <dx-select-box *ngIf="Info.data.LimitTypeName === 'Volume'" [dataSource]="__oTradingProducts"
                             displayExpr="TradingProductName"
                             valueExpr="TradingProductName"
                             [(value)]="Info.data.TradingProductName"
                             (onSelectionChanged)="selectbox_onSelectionChanged(Info.data,'lTradingProductId',$event)"
                             [disabled]="false"
                             [searchEnabled]="true">
              </dx-select-box>

            </div>

            <div *dxTemplate="let Info of 'cellTemplateTradingCategoryComboBox'">
              <div *ngIf="Info.data.LimitTypeName === 'Volume' && !isFourEyeRow(Info)" class="col-lg-12 col-sm-12 col-md-12" style="text-align:left">
                {{Info.data.TradingProductName}}
              </div>

              <div *ngIf="Info.data.LimitTypeName !== 'Volume' && !isFourEyeRow(Info)" class="col-lg-12 col-sm-12 col-md-12" style="text-align:left">
                {{Info.data.TradingCategoryName}}
              </div>
            </div>

            <div *dxTemplate="let Info of 'editCellTemplateFromDate'">
              <app-date-picker [disabled]="true" *ngIf="(Info.data.IsTempLimitAllocated && Info.data.TempLimitTenorTypeName == 'Calendar')" type="date" [value]="Info.data.TemporaryLimitFromDate"
                               (onDatePickerValueChanged)="rollingMonth_ValueChanged($event,Info.data,Info.data.RowNumber,'From', 'TemporaryLimitFromDate')"
                               displayFormat="dd MMM yyyy" style="width:100% !important" [min]="Info.data.TemporaryLimitFromDate" [max]="Info.data.TemporaryLimitToDate">
              </app-date-picker>

              <dx-number-box [disabled]="true" *ngIf="(Info.data.IsTempLimitAllocated && Info.data.TempLimitTenorTypeName == 'Rolling')" [(value)]="Info.data.RollingFromMonth" [min]="Info.data.RollingFromMonth" [max]="Info.data.RollingToMonth"
                             (onValueChanged)="rollingMonth_ValueChanged($event,Info.data,Info.data.RowNumber,'From')" style="width:100% !important">
              </dx-number-box>
              <!--[min]="Info.data.RollingFromMonth" [max]="Info.data.RollingToMonth"-->
              <dx-number-box *ngIf="Info.data.TenorTypeName == 'Rolling' && !Info.data.IsTempLimitAllocated"
                             [(value)]="Info.data.RollingFromPeriod"
                             [disabled]="Info.data.IsEditorEnabled"
                             (onValueChanged)="calculateLimitPeriodFromPeriod(Info.data,Info.data.RowNumber,'From',$event)" style="width:100% !important">
              </dx-number-box>
              <!--valueChangeEvent="keyUp" (onkeyUp)="onKeyPressNumberBoxState($event,'tempLimitFromMonth',Info.data)"-->
              <app-date-picker *ngIf="!Info.data.IsTempLimitAllocated && Info.data.TenorTypeName == 'Calendar'" type="date" [value]="Info.data.From"
                               (onDatePickerValueChanged)=" date_ValueChanged($event, Info.data,Info.data.RowNumber,'From', true)" [disabled]="Info.data.IsEditorEnabled"
                               displayFormat="monthAndYear" style="width:100% !important" [min]="__dtMinFrom" [max]="Info.data.To" [calendarOptions]="{zoomLevel:'year', minZoomLevel:'decade',maxZoomLevel:'year'}">
              </app-date-picker>
            </div>
            <div *dxTemplate="let Info of 'cellTemplateFromDate'" [ngClass]="{'parent-entity-lock':isEntityRestrictedRow(Info)}">
              <i *ngIf="isEntityRestrictedRow(Info)" class='glyphicon glyphicon-lock entity-lock'></i>
              <div *ngIf="Info.data.IsTempLimitAllocated && !isFourEyeNewTempLimit(Info)" class="col-lg-12 col-sm-12 col-md-12 limitfont-Size-big padding-left-20">
                <span *ngIf="Info.data.TemporaryLimitFromDate && Info.data.TempLimitTenorTypeName == 'Rolling'">{{Info.data.RollingFromMonth}} ({{Info.data.TemporaryLimitFromDate| date: 'dd MMM yyyy'}})</span>
                <span *ngIf="Info.data.TemporaryLimitFromDate && Info.data.TempLimitTenorTypeName != 'Rolling' ">{{Info.data.TemporaryLimitFromDate| date: 'dd MMM yyyy'}}</span>
              </div>
              <div class="col-lg-12 col-sm-12 col-md-12 padding-left-20" *ngIf="!isFourEyeNewLimit(Info)" [ngClass]="{'limitfont-Size-small':Info.data.IsTempLimitAllocated}" style="text-align:left">
                <span *ngIf="Info.data.TenorTypeName == 'Rolling' && Info.data.From">{{calculatePeriodFromDate(Info.data.From)}} ({{Info.data.From | date: 'MMM-yyyy'}})</span>
                <span *ngIf="Info.data.TenorTypeName != 'Rolling'">{{Info.data.From | date: 'MMM-yyyy'}}</span>
              </div>
            </div>
            <div *dxTemplate="let Info of 'editCellTemplateToDate'">
              <app-date-picker [disabled]="true" *ngIf="(Info.data.IsTempLimitAllocated && Info.data.TempLimitTenorTypeName == 'Calendar') " type="date" [value]="Info.data.TemporaryLimitToDate"
                               (onDatePickerValueChanged)=" rollingMonth_ValueChanged($event,Info.data,Info.data.RowNumber,'To', 'TemporaryLimitToDate')"
                               displayFormat="dd MMM yyyy" style="width:100% !important" [min]="Info.data.TemporaryLimitToDate" [max]="Info.data.TemporaryLimitToDateMax">
              </app-date-picker>

              <dx-number-box [disabled]="true" *ngIf="(Info.data.IsTempLimitAllocated && Info.data.TempLimitTenorTypeName == 'Rolling') " [(value)]="Info.data.RollingToMonth" [min]="Info.data.RollingToMonth" [max]="Info.data.RollingToMonthMax"
                             (onValueChanged)="rollingMonth_ValueChanged($event,Info.data,Info.data.RowNumber,'To')" style="width:100% !important">
              </dx-number-box>
              <!--valueChangeEvent="keyUp"  (onkeyUp)="onKeyPressNumberBoxState($event,'tempLimitToMonth',Info.data)"-->
              <dx-number-box *ngIf="Info.data.TenorTypeName == 'Rolling' && !Info.data.IsTempLimitAllocated"
                             [(value)]="Info.data.RollingToPeriod"
                             [disabled]="Info.data.IsEditorEnabled"
                             (onValueChanged)="calculateLimitPeriodFromPeriod(Info.data,Info.data.RowNumber,'To',$event)" style="width:100% !important">
              </dx-number-box>
              <app-date-picker *ngIf="!Info.data.IsTempLimitAllocated && Info.data.TenorTypeName == 'Calendar'" type="date" [value]="Info.data.To" (onDatePickerValueChanged)=" date_ValueChanged($event, Info.data,Info.data.RowNumber,'To', true)" [disabled]="Info.data.IsEditorEnabled"
                               displayFormat="monthAndYear" style="width:100% !important" [min]="Info.data.From" [max]="__dtMaxDate" [calendarOptions]="{zoomLevel:'year', minZoomLevel:'decade',maxZoomLevel:'year'}">
              </app-date-picker>
            </div>

            <div *dxTemplate="let Info of 'cellTemplateToDate'" [ngClass]="{'parent-entity-lock':isEntityRestrictedRow(Info)}">
              <i *ngIf="isEntityRestrictedRow(Info)" class='glyphicon glyphicon-lock entity-lock'></i>
              <div *ngIf="Info.data.IsTempLimitAllocated && !isFourEyeNewTempLimit(Info)" class="col-lg-12 col-sm-12 col-md-12 limitfont-Size-big padding-left-20">
                <span *ngIf="Info.data.TempLimitTenorTypeName == 'Rolling' && Info.data.TemporaryLimitToDate"> {{Info.data.RollingToMonth}} ({{Info.data.TemporaryLimitToDate | date: 'dd MMM yyyy'}})</span>
                <span *ngIf="Info.data.TempLimitTenorTypeName != 'Rolling' && Info.data.TemporaryLimitToDate"> {{Info.data.TemporaryLimitToDate | date: 'dd MMM yyyy'}}</span>
              </div>
              <div class="col-lg-12 col-sm-12 col-md-12 padding-left-20" *ngIf="!isFourEyeNewLimit(Info)" [ngClass]="{'limitfont-Size-small':Info.data.IsTempLimitAllocated}" style="text-align:left">
                <span *ngIf="Info.data.TenorTypeName == 'Rolling' && Info.data.To">{{calculatePeriodFromDate(Info.data.To)}} ({{Info.data.To | date: 'MMM-yyyy'}})</span>
                <span *ngIf="Info.data.TenorTypeName != 'Rolling'">{{Info.data.To | date: 'MMM-yyyy'}}</span>
              </div>

            </div>


            <div *dxTemplate="let Info of 'cellTemplateLimitValue'">
              <!-- CRD-420-Pawan Prajapati { iIndex: Info.columnIndex-__iColumnCountBeforeLimitValue } as oInfo-->
              <div *ngIf="__bTimelineViewVisible && { iIndex: Info.columnIndex-__iColumnCountBeforeLimitValue } as oInfo" class="col-lg-12 col-sm-12 col-md-12 padding0px">
                <div class="col-lg-12 col-sm-12 col-md-12 limit-cell-container" [ngClass]="{'limit-value-cell-with-calendar': !Info.data.DataValues[oInfo.iIndex].IsEditorVisible}">
                  <div class="padding0px col-lg-12 col-sm-12 col-md-12 " [ngClass]="{'limit-value-cell-with-calendar': !Info.data.DataValues[oInfo.iIndex].IsDisabled}">
                    <span *ngIf="((!Info.data.IsTempLimitAllocated || (!Info.data.TempDataValues[oInfo.iIndex] || Info.data.TempDataValues[oInfo.iIndex].EntityState === 3 || (!Info.data.TempDataValues[oInfo.iIndex].LimitValue && Info.data.TempDataValues[oInfo.iIndex].LimitValue !== 0))) && Info.data.TradingCategoryName !== 'Overall' && Info.data.DataValues[oInfo.iIndex].IsEditorVisible && !Info.data.DataValues[oInfo.iIndex].IsDisabled)" class="max-container">
                      <span *ngIf="Info.data.DataValues[oInfo.iIndex].MaxAllocation >= 0">
                        Max {{Info.data.CurrencyName}} {{Info.data.DataValues[oInfo.iIndex].MaxAllocation.toLocaleString()}}
                      </span>
                      <span *ngIf="Info.data.DataValues[oInfo.iIndex].MaxAllocation < 0">
                        <i class='glyphicon glyphicon-alert' style='color: #f1a100;' (click)="alert(Info.data,oInfo.iIndex,'warnings')">
                        </i>
                      </span>
                      <span *ngIf="(Info.data.IsTempLimitAllocated && Info.data.TempDataValues[oInfo.iIndex] && Info.data.TempDataValues[oInfo.iIndex].EntityState !== 3 && (Info.data.TempDataValues[oInfo.iIndex].LimitValue || Info.data.TempDataValues[oInfo.iIndex].LimitValue === 0) && Info.data.TradingCategoryName !== 'Overall' && Info.data.TempDataValues[oInfo.iIndex].IsEditorVisible && !Info.data.TempDataValues[oInfo.iIndex].IsDisabled)" class="max-container">
                        <span *ngIf="Info.data.TempDataValues[oInfo.iIndex].MaxAllocation >= 0">
                          Max {{Info.data.TempDataValues[oInfo.iIndex].MaxAllocation}}
                        </span>
                        <span *ngIf="Info.data.TempDataValues[oInfo.iIndex].MaxAllocation < 0">
                          <i class='glyphicon glyphicon-alert' style='color: #f1a100;' (click)="alert(Info.data,oInfo.iIndex,'warnings')">
                          </i>
                        </span>
                      </span>
                    </span>
                    <dx-number-box id="nbTimelineView" *ngIf="Info.data.IsTempLimitAllocated && (Info.data.TempLimitTenorTypeName == 'Calendar' || (Info.data.TempLimitTenorTypeName == 'Rolling' && !Info.data.TempDataValues[oInfo.iIndex]?.IsLimitExpired)) && Info.data.TempDataValues[oInfo.iIndex] && Info.data.TempDataValues[oInfo.iIndex].EntityState !== 3 && (Info.data.TempDataValues[oInfo.iIndex].LimitValue || Info.data.TempDataValues[oInfo.iIndex].LimitValue === 0)"
                                   [disabled]="Info.data.TempDataValues[oInfo.iIndex].IsDisabled" (onFocusOut)="numberBox_FocusOut(Info.data,oInfo.iIndex)"
                                   [(value)]="Info.data.TempDataValues[oInfo.iIndex].LimitValue" format="#,##0.##;-#,##0.##"
                                   (onKeyUp)="numberBox_KeyPress($event,Info.data,oInfo.iIndex,Info.rowIndex,'templimitvalue')"
                                   (onValueChanged)="limitValue_Changed($event,Info.data,Info.data.RowNumber,oInfo.iIndex,true)" style="text-align:right;">
                    </dx-number-box>
                    <dx-number-box id="nbTempTimelineView" *ngIf="!Info.data.IsTempLimitAllocated || (!Info.data.TempDataValues[oInfo.iIndex] || Info.data.TempDataValues[oInfo.iIndex].EntityState === 3 || (!Info.data.TempDataValues[oInfo.iIndex].LimitValue && Info.data.TempDataValues[oInfo.iIndex].LimitValue !== 0)) || (Info.data.TempLimitTenorTypeName == 'Rolling' && Info.data.TempDataValues[oInfo.iIndex]?.IsLimitExpired)"
                                   [disabled]="Info.data.DataValues[oInfo.iIndex].IsDisabled || Info.data.IsEditorEnabled" (onFocusOut)="numberBox_FocusOut(Info.data,oInfo.iIndex)"
                                   [(value)]="Info.data.DataValues[oInfo.iIndex].LimitValue" format="#,##0.##;-#,##0.##"
                                   (onKeyUp)="numberBox_KeyPress($event,Info.data,oInfo.iIndex,Info.rowIndex,'limitvalue')"
                                   (onValueChanged)="limitValue_Changed($event,Info.data,Info.data.RowNumber,oInfo.iIndex,false)" style="text-align:right;">
                    </dx-number-box>
                  </div>
                  <div *ngIf="Info.data.IsTempLimitAllocated && Info.data.TempDataValues[oInfo.iIndex] && Info.data.TempDataValues[oInfo.iIndex].EntityState !== 3 && (Info.data.TempDataValues[oInfo.iIndex].LimitValue || Info.data.TempDataValues[oInfo.iIndex].LimitValue === 0) && Info.data.TempDataValues[oInfo.iIndex].IsEditorVisible && !Info.data.TempDataValues[oInfo.iIndex].IsDisabled && (Info.data.TempLimitTenorTypeName == 'Calendar' || (Info.data.TempLimitTenorTypeName == 'Rolling' && !Info.data.TempDataValues[oInfo.iIndex]?.IsLimitExpired))" class="padding0px calendar-cell">
                    <dx-button id="btnEdit" icon="glyphicon glyphicon-calendar" class="sidebar-calendar-icon"
                               (onClick)="btnLimitValue_Clicked(Info.data.TempDataValues[oInfo.iIndex],Info.data,oInfo.iIndex)">
                    </dx-button>
                  </div>

                  <div *ngIf="(!Info.data.IsTempLimitAllocated || (!Info.data.TempDataValues[oInfo.iIndex] || Info.data.TempDataValues[oInfo.iIndex].EntityState === 3 ||(!Info.data.TempDataValues[oInfo.iIndex].LimitValue && Info.data.TempDataValues[oInfo.iIndex].LimitValue !== 0))) && Info.data.DataValues[oInfo.iIndex].IsEditorVisible && !Info.data.DataValues[oInfo.iIndex].IsDisabled || (Info.data.TempLimitTenorTypeName == 'Rolling' && Info.data.TempDataValues[oInfo.iIndex] && Info.data.TempDataValues[oInfo.iIndex]?.IsLimitExpired)" class="padding0px calendar-cell">
                    <dx-button [disabled]="Info.data.IsEditorEnabled" id="btnEdit" icon="glyphicon glyphicon-calendar" class="sidebar-calendar-icon"
                               (onClick)="btnLimitValue_Clicked(Info.data.DataValues[oInfo.iIndex],Info.data,oInfo.iIndex)">
                    </dx-button>
                  </div>
                </div>
              </div>
              <!-- CRD-420-Pawan Prajapati { iIndex: Info.columnIndex-__iColumnCountBeforeLimitValue } as oInfo-->
              <div *ngIf="!__bTimelineViewVisible && { iIndex: Info.columnIndex-__iColumnCountBeforeLimitValue } as oInfo" class="col-lg-12 col-sm-12 col-md-12 padding0px">
                <div class="col-lg-12 col-sm-12 col-md-12 limit-cell-container" [ngClass]="{'limit-value-cell-with-calendar': !Info.data.DataValues[oInfo.iIndex].IsEditorVisible}">
                  <div class="padding0px col-lg-12 col-sm-12 col-md-12" [ngClass]="{'limit-value-cell-with-calendar': !Info.data.DataValues[oInfo.iIndex].IsDisabled || (Info.data.TempDataValues && !Info.data.TempDataValues[oInfo.iIndex].IsDisabled && Info.data.IsTempLimitAllocated && Info.data.TempDataValues[oInfo.iIndex] && (Info.data.TempDataValues[oInfo.iIndex].LimitValue || Info.data.TempDataValues[oInfo.iIndex].LimitValue === 0))}">
                    <span *ngIf="((!Info.data.IsTempLimitAllocated || (!Info.data.TempDataValues[oInfo.iIndex] || Info.data.TempDataValues[oInfo.iIndex].EntityState === 3 ||(!Info.data.TempDataValues[oInfo.iIndex].LimitValue && Info.data.TempDataValues[oInfo.iIndex].LimitValue !== 0))) && Info.data.TradingCategoryName !== 'Overall' && Info.data.DataValues[oInfo.iIndex].IsEditorVisible && !Info.data.DataValues[oInfo.iIndex].IsDisabled)" class="max-container">
                      <span *ngIf="Info.data.DataValues[oInfo.iIndex].MaxAllocation >= 0">
                        Max {{Info.data.CurrencyName}} {{Info.data.DataValues[oInfo.iIndex].MaxAllocation.toLocaleString()}}
                      </span>

                      <span *ngIf="Info.data.DataValues[oInfo.iIndex].MaxAllocation < 0">
                        <i class='glyphicon glyphicon-alert' style='font-size:16px;color: #f1a100;' (click)="alert(Info.data,oInfo.iIndex,'warnings')">
                        </i>
                      </span>
                    </span>
                    <span *ngIf="(Info.data.IsTempLimitAllocated && Info.data.TempDataValues[oInfo.iIndex] && Info.data.TempDataValues[oInfo.iIndex].EntityState !== 3 && (Info.data.TempDataValues[oInfo.iIndex].LimitValue || Info.data.TempDataValues[oInfo.iIndex].LimitValue === 0) && Info.data.TradingCategoryName !== 'Overall' && Info.data.TempDataValues[oInfo.iIndex].IsEditorVisible && !Info.data.TempDataValues[oInfo.iIndex].IsDisabled)" class="max-container">
                      <span *ngIf="Info.data.TempDataValues[oInfo.iIndex].MaxAllocation >= 0">
                        Max {{Info.data.TempDataValues[oInfo.iIndex].MaxAllocation}}
                      </span>
                    </span>

                    <dx-number-box id="nbSimpleView" *ngIf="Info.data.IsTempLimitAllocated && (Info.data.TempLimitTenorTypeName == 'Calendar' || (Info.data.TempLimitTenorTypeName == 'Rolling' && !Info.data.TempDataValues[oInfo.iIndex]?.IsLimitExpired)) && Info.data.TempDataValues[oInfo.iIndex] && Info.data.TempDataValues[oInfo.iIndex].EntityState !== 3 && (Info.data.TempDataValues[oInfo.iIndex].LimitValue || Info.data.TempDataValues[oInfo.iIndex].LimitValue === 0)"
                                   [disabled]="Info.data.TempDataValues[oInfo.iIndex].IsDisabled" (onFocusOut)="numberBox_FocusOut(Info.data,oInfo.iIndex)"
                                   [(value)]="Info.data.TempDataValues[oInfo.iIndex].LimitValue" format="#,##0.##;-#,##0.##"
                                   (onKeyUp)="numberBox_KeyPress($event,Info.data,oInfo.iIndex,Info.rowIndex,'templimitvalue')"
                                   (onValueChanged)="limitValue_Changed($event,Info.data,Info.data.RowNumber,oInfo.iIndex,true)" style="text-align:right;">
                    </dx-number-box>

                    <dx-number-box id="nbTempSimpleView" *ngIf="!Info.data.IsTempLimitAllocated || (!Info.data.TempDataValues[oInfo.iIndex] || Info.data.TempDataValues[oInfo.iIndex].EntityState === 3 || (!Info.data.TempDataValues[oInfo.iIndex].LimitValue && Info.data.TempDataValues[oInfo.iIndex].LimitValue !== 0)) || (Info.data.TempLimitTenorTypeName == 'Rolling' && Info.data.TempDataValues[oInfo.iIndex]?.IsLimitExpired)"
                                   [disabled]="Info.data.DataValues[oInfo.iIndex].IsDisabled || Info.data.IsEditorEnabled" (onFocusOut)="numberBox_FocusOut(Info.data,oInfo.iIndex)"
                                   [(value)]="Info.data.DataValues[oInfo.iIndex].LimitValue" format="#,##0.##;-#,##0.##"
                                   (onKeyUp)="numberBox_KeyPress($event,Info.data,oInfo.iIndex,Info.rowIndex,'limitvalue')"
                                   (onValueChanged)="limitValue_Changed($event,Info.data,Info.data.RowNumber,oInfo.iIndex,false)" style="text-align:right;">
                    </dx-number-box>
                  </div>
                  <div *ngIf="Info.data.IsTempLimitAllocated && Info.data.TempDataValues[oInfo.iIndex] && Info.data.TempDataValues[oInfo.iIndex].EntityState !== 3 && (Info.data.TempDataValues[oInfo.iIndex].LimitValue || Info.data.TempDataValues[oInfo.iIndex].LimitValue === 0) && Info.data.TempDataValues[oInfo.iIndex].IsEditorVisible && !Info.data.TempDataValues[oInfo.iIndex].IsDisabled" class="padding0px calendar-cell">
                    <dx-button id="btnEdit" icon="glyphicon glyphicon-calendar" class="sidebar-calendar-icon"
                               (onClick)="btnLimitValue_Clicked(Info.data.TempDataValues[oInfo.iIndex],Info.data,oInfo.iIndex)">
                    </dx-button>
                  </div>
                  <div *ngIf="(!Info.data.IsTempLimitAllocated || (!Info.data.TempDataValues[oInfo.iIndex] || Info.data.TempDataValues[oInfo.iIndex].EntityState === 3 || (!Info.data.TempDataValues[oInfo.iIndex].LimitValue && Info.data.TempDataValues[oInfo.iIndex].LimitValue !== 0))) && Info.data.DataValues[oInfo.iIndex].IsEditorVisible && !Info.data.DataValues[oInfo.iIndex].IsDisabled" class="padding0px calendar-cell">
                    <dx-button [disabled]="Info.data.DataValues[oInfo.iIndex].IsDisabled || Info.data.IsEditorEnabled" id="btnEdit" icon="glyphicon glyphicon-calendar" class="sidebar-calendar-icon"
                               (onClick)="btnLimitValue_Clicked(Info.data.DataValues[oInfo.iIndex],Info.data,oInfo.iIndex)">
                    </dx-button>
                  </div>
                </div>
              </div>
              <!--[disabled]="((Info.data.DataValues[oInfo.iIndex-1].LimitValue == undefined || Info.data.DataValues[oInfo.iIndex-1].LimitValue == null ||Info.data.DataValues[oInfo.iIndex-1].LimitValue === '') && (oInfo.iIndex-1 != 7))"-->
              <!--[ngClass]="{'cellHeight': Info.data.DataValues[oInfo.iIndex].IsOverAllocation,'defaultCellHeight': !Info.data.DataValues[oInfo.iIndex].IsOverAllocation}"-->
            </div>

            <div *dxTemplate="let Info of 'cellTemplate'">
              <!-- CRD-420-Pawan Prajapati { iIndex: Info.columnIndex-__iColumnCountBeforeLimitValue } as oInfo-->
              <div class="col-lg-12 col-sm-12 col-md-12 padding0px" *ngIf="{ iIndex: Info.columnIndex-__iColumnCountBeforeLimitValue } as oInfo">
                <div *ngIf="Info.data.IsEditButtonClicked && Info.data.TradingCategoryName !== 'Overall' && Info.data.LimitTypeName !== 'Volume' && Info.data.TradingCategoryName !== 'Headroom' && __bTimelineViewVisible && __bSideBar" class="col-lg-12 col-sm-12 col-md-12 padding0px">
                  <span [ngClass]="{'backgroundyellow':(__bSidebarApply && Info.data.DataValues[oInfo.iIndex].IsOverAllocation),'backgroundblue': (((oInfo.iIndex >= 0) && !Info.data.DataValues[oInfo.iIndex].IsOverAllocation && ((Info.data.DataValues[oInfo.iIndex].ColourVariant % 2) !== 0))),'backgroundpurple': ((oInfo.iIndex >= 0) && !Info.data.DataValues[oInfo.iIndex].IsOverAllocation && ((Info.data.DataValues[oInfo.iIndex].ColourVariant % 2) === 0))}">
                    <span *ngIf="Info.data.DataValues[oInfo.iIndex].MaxAllocation >= 0">
                      Max {{Info.data.CurrencyName}} {{Info.data.DataValues[oInfo.iIndex].MaxAllocation.toLocaleString()}}
                    </span>
                    <span *ngIf="Info.data.DataValues[oInfo.iIndex].MaxAllocation < 0">
                      <i class='glyphicon glyphicon-alert' style='color: #f1a100;' (click)="alert(Info.data,oInfo.iIndex,'warnings')">
                      </i>
                    </span>
                  </span>

                </div>
                <div *ngIf="Info.data.IsTempLimitAllocated && !isFourEyeNewTempLimit(Info) && ( (isFourEyeRow(Info) && Info.data.TempDataValues[oInfo.iIndex].LimitValue) || Info.data.TempLimitTenorTypeName == 'Calendar' || (Info.data.TempLimitTenorTypeName == 'Rolling' && !Info.data.TempDataValues[oInfo.iIndex]?.IsLimitExpired))" class="limitfont-Size-big relative-position" style="text-align:right;" [ngClass]="{'col-lg-10 col-sm-10 col-md-10': (Info.data.TradingCategoryName == 'Overall' && Info.data.Warnings.length > 0 && !__bTimelineViewVisible)}">
                  <i class='glyphicon glyphicon-lock limitvalue-lock-icon' [title]="Info.data.TempLimitvalueDisabledMessage" *ngIf="Info.data.lCounterpartyLimitId>0 && !isFourEyeRow(Info) && Info.data.TempLimitvalueDisabledMessage && Info.data.TempDataValues[oInfo.iIndex].LimitValue && Info.data.TempDataValues[oInfo.iIndex].IsDisabled"></i>
                  <i class='glyphicon glyphicon-lock limitvalue-lock-icon' *ngIf="isEntityRestrictedRow(Info) && Info.data.TempDataValues[oInfo.iIndex].LimitValue"></i>
                  <span class="limitfont-Size-big">{{Info.data.TempDataValues[oInfo.iIndex] && Info.data.TempDataValues[oInfo.iIndex].EntityState !== 3 && (Info.data.TempDataValues[oInfo.iIndex].LimitValue || Info.data.TempDataValues[oInfo.iIndex].LimitValue === 0) ? Info.data.TempDataValues[oInfo.iIndex].LimitValue.toLocaleString():null}}</span>
                  <br />
                  <span class="limitfont-Size-small" *ngIf="!isFourEyeRow(Info) && Info.data.IsTempLimitValueVaryingOverTime && !__bTimelineViewVisible">varies over time</span>
                </div>

                <div class="col-lg-12 col-sm-12 col-md-12 relative-position" *ngIf="!isFourEyeNewLimit(Info)" [ngClass]="{'col-lg-10 col-sm-10 col-md-10': ((Info.data.TradingCategoryName == 'Overall'|| Info.data.IsOverall === 1) && Info.data.Warnings.length > 0 && !__bTimelineViewVisible),'limitfont-Size-small':(Info.data.IsTempLimitAllocated && Info.data.TempDataValues && Info.data.TempDataValues[oInfo.iIndex] && Info.data.TempDataValues[oInfo.iIndex].EntityState !== 3 && (Info.data.TempDataValues[oInfo.iIndex].LimitValue || Info.data.TempDataValues[oInfo.iIndex].LimitValue === 0)) && (Info.data.TempLimitTenorTypeName == 'Calendar' || (Info.data.TempLimitTenorTypeName == 'Rolling' && !Info.data.TempDataValues[oInfo.iIndex]?.IsLimitExpired))}"
                     style="padding: 0px;text-align:right;">
                  <i class='glyphicon glyphicon-lock limitvalue-lock-icon' [ngStyle]="{top:Info.data.IsTempLimitAllocated?'-1.7rem':'0rem'}" [title]="Info.data.PermanentLimitvalueDisabledMessage" *ngIf="Info.data.lCounterpartyLimitId>0 && !isFourEyeRow(Info) && Info.data.PermanentLimitvalueDisabledMessage && Info.data.DataValues[oInfo.iIndex].LimitValue && Info.data.DataValues[oInfo.iIndex].IsDisabled && (!(Info.data.TempDataValues[oInfo.iIndex] && Info.data.TempDataValues[oInfo.iIndex].LimitValue) || !Info.data.IsTempLimitAllocated)"></i>
                  <i class='glyphicon glyphicon-lock limitvalue-lock-icon' [ngStyle]="{top:Info.data.IsTempLimitAllocated?'-1.7rem':'0rem'}" *ngIf="isEntityRestrictedRow(Info) && Info.data.DataValues[oInfo.iIndex].LimitValue && (!(Info.data.TempDataValues && Info.data.TempDataValues[oInfo.iIndex] && Info.data.TempDataValues[oInfo.iIndex].LimitValue) || !Info.data.IsTempLimitAllocated)"></i>
                  {{Info.data.DataValues[oInfo.iIndex].LimitValue ? Info.data.DataValues[oInfo.iIndex].LimitValue.toLocaleString():Info.data.DataValues[oInfo.iIndex].LimitValue}}
                  <br *ngIf="__bTimelineViewVisible && Info.data.TradingCounterpartyLimit && (Info.data.DataValues[oInfo.iIndex].lOverallLimitSettingId == 2 || Info.data.DataValues[oInfo.iIndex].lOverallLimitSettingId == 1)" />
                  <span class='limitfont-Size-small lc-pcg-label' *ngIf="__bTimelineViewVisible && Info.data.DataValues[oInfo.iIndex] && Info.data.DataValues[oInfo.iIndex].lOverallLimitSettingId == 1">Guarantee</span>
                  <span class='limitfont-Size-small lc-pcg-label' *ngIf="__bTimelineViewVisible && Info.data.DataValues[oInfo.iIndex] && Info.data.DataValues[oInfo.iIndex].lOverallLimitSettingId == 2">LC</span>
                </div>

                <div *ngIf="!isFourEyeRow(Info) && Info.data.IsLimitValueVaryingOverTime && !__bTimelineViewVisible" class="col-lg-12 col-sm-12 col-md-12" [ngClass]="{'col-lg-10 col-sm-10 col-md-10': ((Info.data.TradingCategoryName == 'Headroom'|| Info.data.TradingCategoryName == 'Overall'|| Info.data.IsOverall === 1) && Info.data.Warnings.length > 0 && !__bTimelineViewVisible)}"
                     style="padding: 0px; text-align:center;">
                  <font color="slategrey" style="font-size:12.5px; width:100%">varies over time</font>
                </div>

                <div *ngIf="!isFourEyeRow(Info) && !Info.data.IsEditButtonClicked && Info.data.DataValues[oInfo.iIndex].IsOverAllocation && (Info.data.TradingCategoryName == 'Headroom' || Info.data.TradingCategoryName == 'Overall'|| Info.data.IsOverall === 1) && __bTimelineViewVisible" class="col-lg-12 col-sm-12 col-md-12 padding0px" style="text-align:center">
                  <span id="spnOverAllocation">
                    <!--<i class='fas fa-exclamation-triangle' style='font-size:16px;color:#ffffff'></i>-->
                    <font color="#f1a100" style="font-size:12.5px; width:100%">Over allocation</font>
                  </span>
                </div>
              </div>
            </div>

          </dx-tree-list>
        </div>
        <div *ngIf="__bSideBar" id="limitSideBar">
          <app-LimitSideBar-Tab [__bSideBar]="__bSideBar" [__bIsLoadedFromDataSearch]="__bIsLoadedFromDataSearch" (getSideBarChange)="getSideBarChangeCallback($event)" [__oSideBarCounterPartyLimit]="__oSideBarCounterPartyLimit" [__dtMinDate]="__dValuationDate" [__dtMaxDate]="__dtMaxDate" (returnSidebarChanges)="returnSidebarChangesCallback($event)"></app-LimitSideBar-Tab>
        </div>
      </div>

    </div>

    <div id="reviewDateTab" [hidden]="__sTabContent != 'Limit Review Dates'" class="col-lg-12 col-md-12 col-xs-12 padding0px">
      <app-ReviewDate [__oCounterpartyLimits]="__oDatasource" (getReviewDateUpdated)="getReviewDateUpdatedCallBack($event)" (getReviewDateUpdateCancelled)="getReviewDateUpdateCancelledCallBack($event)"></app-ReviewDate>
    </div>

    <div id="PCGTab" [hidden]="__sTabContent != 'PCG Hierarchy'" class="col-lg-12 col-md-12 col-xs-12 padding0px">
      <!--<app-CustomProperty-Application [__sEntityGroupName]="__sEntityGroup"></app-CustomProperty-Application>-->
    </div>

    <div id="CustomPropertiesTab" [hidden]="__sTabContent != 'Custom Properties'" [ngClass]="{'extended-CustomPropertiesTab':__bIsLoadedFromDataSearch}" class="col-lg-12 col-md-12 col-xs-12 padding0px">
      <app-CustomProperty-Application [__sEntityGroupName]="__sEntityGroup"></app-CustomProperty-Application>
    </div>

  </div>

  <div class="col-lg-12 col-md-12 col-xs-12 padding0px div-common-Save">
    <table class="table">
      <tr>
        <td class="table-cell-audit-text"><!--<div class="div-audit-info">{{__sAuditTrailInfoAIP}}</div>--></td>
        <td class="table-cell-audit-button">
          <dx-button id="btnCancel" (onClick)="btnCancel_Clicked()" text="Cancel" [disabled]="false"></dx-button>
        </td>
        <td class="table-cell-audit-button text-alignment-right">
          <dx-button [disabled]="!__bDisableSave" id="btnSave" (onClick)="btnSave_Clicked()" text="Save"></dx-button>
        </td>

      </tr>
    </table>
  </div>
  <dx-load-panel id="pnlLoad"
                 shadingColor="rgba(0,0,0,0.4)"
                 [position]="{ of: '#divlimits' }"
                 [(visible)]="__bIsLimitLoadingVisible"
                 [showIndicator]="true"
                 [showPane]="true"
                 [shading]="true"
                 [hideOnOutsideClick]="false"
                 [height]="75"
                 [width]="150"
                 message="Please Wait...">
  </dx-load-panel>

  <dx-popup [wrapperAttr]="{ class: 'popupSample' }"
            id="popupAddNewLimit"
            [width]="615"
            [height]="'auto'"
            [showTitle]="true"
            title="Add New Limit"
            [dragEnabled]="false"
            [hideOnOutsideClick]="false"
            [(visible)]="__bAddNewVisible">
    <div *dxTemplate="let data of 'content'">

      <div class="row message-border">
        <div class="col-lg-12 col-md-12 col-xs-12 add-limit-message-box">
          <div id="form-limit">
            <div class="col-lg-12 col-md-12 col-xs-12 padding0px" style="margin-bottom: 2.1rem;">
              <div class="dx-field">
                <div class="dx-field-label">Counterparty<font color="red">*</font></div>
                <div class="dx-field-value" style="margin-right:9px;">
                  <dx-select-box id="cbCounterparty" [dataSource]="__oLimitCounterParties"
                                 displayExpr="TradingCounterpartyName"
                                 valueExpr="TradingCounterpartyName"
                                 [(value)]="__oNewLimit.TradingCounterpartyName"
                                 (onSelectionChanged)="onCheckOverallLimitExistOrNot()"
                                 [searchEnabled]="true">
                  </dx-select-box>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">Our Entity<font color="red">*</font></div>
                <div class="dx-field-value" style="margin-right:9px;">
                  <dx-select-box id="cbTradingEntity" [dataSource]="__oTradingEntities"
                                 displayExpr="TradingEntityName"
                                 valueExpr="TradingEntityName"
                                 [(value)]="__oNewLimit.TradingEntityName"
                                 (onSelectionChanged)="onCheckOverallLimitExistOrNot()"
                                 [searchEnabled]="true">
                  </dx-select-box>

                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">Limit Type<font color="red">*</font></div>
                <div class="dx-field-value" style="margin-right:9px;">
                  <dx-select-box id="cbLimitType" [dataSource]="__oLimitTypes"
                                 displayExpr="LimitTypeName"
                                 valueExpr="LimitTypeName"
                                 [(value)]="__oNewLimit.LimitTypeName"
                                 (onSelectionChanged)="onCheckOverallLimitExistOrNot()"
                                 [searchEnabled]="true">
                  </dx-select-box>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label"><span *ngIf="__oNewLimit.LimitTypeName !=='Volume'">Trading Category</span><span *ngIf="__oNewLimit.LimitTypeName ==='Volume'"> Trading Product:</span><font color="red">*</font></div>
                <div class="dx-field-value" style="margin-right:9px;">
                  <dx-select-box *ngIf="__oNewLimit.LimitTypeName !=='Volume'" id="cbTradingCategory" [dataSource]="__oPopupTradingCategories"
                                 displayExpr="TradingCategoryName"
                                 valueExpr="TradingCategoryName"
                                 [(value)]="__oNewLimit.TradingCategoryName"
                                 (onSelectionChanged)="onCheckOverallLimitExistOrNot()"
                                 [searchEnabled]="true"
                                 itemTemplate="item">
                    <div *dxTemplate="let data of 'item'">
                      <div *ngIf="data.IsOverall || data.TradingCategoryName === 'Overall'" style="font-weight:bold">{{data.TradingCategoryName}}</div>
                      <div *ngIf="!data.IsOverall && data.TradingCategoryName !== 'Overall'">{{data.TradingCategoryName}}</div>
                    </div>
                  </dx-select-box>
                  <dx-select-box *ngIf="__oNewLimit.LimitTypeName==='Volume'" id="cbTradingProduct" [dataSource]="__oTradingProducts"
                                 displayExpr="TradingProductName"
                                 valueExpr="TradingProductName"
                                 [(value)]="__oNewLimit.TradingProductName"
                                 (onSelectionChanged)="onCheckOverallLimitExistOrNot()"
                                 [searchEnabled]="true">
                  </dx-select-box>
                </div>
              </div>
            </div>


            <div class="col-lg-12 col-md-12 col-xs-12 add-limit-msg" *ngIf="__bIsOverallNeedToBeCreate || (__sPopupDuplicateMessage && !__bIsAddNewLimitFormFilled)" [ngStyle]="{'background':__bIsOverallNeedToBeCreate?'#ffa33e':'#f44336'}">
              <span *ngIf="__sPopupDuplicateMessage && !__bIsAddNewLimitFormFilled">{{__sPopupDuplicateMessage}}</span>
              <span *ngIf="__bIsOverallNeedToBeCreate"> There is no Overall Limit for this combination. If you continue the system will create one, Are you sure you want to continue?</span>
            </div>

          </div>
        </div>
      </div>

      <div class="row" style="margin: 0px; ">
        <div class="col-lg-12 col-md-12 col-xs-12 btn-section">
          <div class="col-lg-9 col-md-9 col-xs-9 padding0px" style="float: right;">
            <dx-button id="btnPopUpCancel" (onClick)="btnPopUpCancel_Click()" text="Cancel"></dx-button>
            <dx-button [disabled]="(!this.__oNewLimit.TradingCounterpartyName || !this.__oNewLimit.TradingEntityName || !this.__oNewLimit.LimitTypeName ||
                       (!this.__oNewLimit.TradingCategoryName && !this.__oNewLimit.TradingProductName))"
                       id="btnOk" (onClick)="btnContinue_Click(false)" text="Continue"></dx-button>
          </div>
        </div>
      </div>

    </div>
  </dx-popup>

  <dx-popup [wrapperAttr]="{ class: 'popupSample' }"
            id="popupAddNewTempLimit"
            [width]="760"
            [height]="'auto'"
            [showTitle]="true"
            title="Adding Temporary Limit"
            [dragEnabled]="false"
            [hideOnOutsideClick]="false"
            [(visible)]="__bAddNewTemporaryLimitVisible">
    <div *dxTemplate="let data of 'content'">
      <div class="row message-border">
        <div class="col-lg-12 col-md-12 col-xs-12 message-box">
          <div id="form-limit">
            <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
              <div *ngIf="__bAddNewTemporaryLimitVisible" class="col-lg-12 col-md-12 col-xs-12 padding0px">
                <div class="col-lg-10 col-md-10 col-xs-10 padding0px margin-bottom-05rem">
                  <span class="dx-field-label width-100">Please fill the form below:</span>
                </div>
                <div class="col-lg-2 col-md-2 col-xs-2 padding0px">
                  <span class="dx-field-label width-100">Period</span>
                </div>
                <div class="col-lg-10 col-md-10 col-xs-10 padding0px">
                  <div class="dx-field">
                    <div class="dx-field-label">From:<font color="red" *ngIf="__oNewTempLimit.ActiveFrom == undefined || __oNewTempLimit.ActiveFrom == ''">*</font></div>
                    <div class="dx-field-value">
                      <div class="col-md-11 padding0px">
                        <app-date-picker type="date" [value]="__oNewTempLimit.ActiveFrom"
                                         displayFormat="dd MMM yyyy" (onDatePickerValueChanged)="__oNewTempLimit.ActiveFrom=$event.value; rollingMonth(__oNewTempLimit.ActiveFrom,'tempLimitActiveFrom',true, $event)"
                                         style="width:100% !important" [min]="__dtMinTempDate" [max]="__dtMaxTempDate">
                        </app-date-picker>
                      </div>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">To:<font color="red" *ngIf="__oNewTempLimit.ActiveUntil == undefined || __oNewTempLimit.ActiveUntil == ''">*</font></div>
                    <div class="dx-field-value">
                      <div class="col-md-11 padding0px">
                        <app-date-picker id="dtActiveUntil" type="date" [value]="__oNewTempLimit.ActiveUntil" (onDatePickerValueChanged)="__oNewTempLimit.ActiveUntil=$event.value; rollingMonth(__oNewTempLimit.ActiveUntil,'tempLimitActiveUntil',true, $event)"
                                         displayFormat="dd MMM yyyy" [min]="__oNewTempLimit.ActiveFrom" [max]="__oNewTempLimit.Info.data.TemporaryLimitToDateMax"
                                         style="width: 100%; ">
                        </app-date-picker>
                      </div>

                    </div>


                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label">Temporary Limit Value:<font color="red" *ngIf="__oNewTempLimit.LimitValue == undefined || __oNewTempLimit.LimitValue == ''">*</font></div>
                    <div class="dx-field-value">
                      <div class="col-md-11 padding0px">
                        <dx-number-box [(value)]="__oNewTempLimit.LimitValue" format="#,##0.##" (onFocusOut)="tempLimit_FocusOut(__oNewTempLimit.LimitValue)"
                                       (onKeyUp)="onKeyPressNumberBoxState($event,'tempLimit')" style="text-align:right;">
                        </dx-number-box>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-2 col-xs-2 padding0px">
                  <div style="padding-top: 4px; ">
                    <p class="periodFont">{{__oNewTempLimit.ActiveFromPeriod}}</p>
                  </div>
                  <div style="padding-top: 4px; ">
                    <p class="periodFont">{{__oNewTempLimit.ActiveUntilPeriod}}</p>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
              <div class="dx-field" style="float:right;">
                <div class="dx-field-label width-100">
                  <span style="color:red" *ngIf="(!__oNewTempLimit.ActiveFrom || !__oNewTempLimit.ActiveUntil || !__oNewTempLimit.LimitValue)">{{__sTempPopupMessage}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin: 0px; ">
        <div class="col-lg-12 col-md-12 col-xs-12 btn-section">
          <div class="col-lg-9 col-md-9 col-xs-9 padding0px" style="float: right;">
            <dx-button id="btnPopUpCancel" (onClick)="btnPopUpCancel_Click()" text="Cancel"></dx-button>
            <dx-button [disabled]="!__oNewTempLimit.ActiveFrom || !__oNewTempLimit.ActiveUntil || !__oNewTempLimit.LimitValue" id="btnOk"
                       (onClick)="btnAddTempLimit_Click(false)" text="Add"></dx-button>
          </div>
        </div>
      </div>

    </div>
  </dx-popup>

  <dx-popup class="popupWarning"
            id="popupWarning"
            [width]="550"
            [height]="'auto'"
            [showTitle]="true"
            titleTemplate="title"
            [dragEnabled]="false"
            [hideOnOutsideClick]="false"
            [(visible)]="__bWarningVisible">
    <div *dxTemplate="let data of 'content'">

      <div class="row message-border">
        <div class="col-lg-12 col-md-12 col-xs-12 message-box">
          <div id="form-limit">
            <div class="col-lg-12 col-md-12 col-xs-12 padding0px" style="overflow-y: auto;height:210px;">
              <!--[title]="__sAlert"-->
              <div *ngFor="let oWarning of __oWarnings" class="dx-field">
                <div class="fieldLabel">
                  <div class="col-lg-6 col-md-6 col-xs-6 padding0px">
                    <span>Over allocation on {{oWarning.ColumnName}} </span>
                  </div>
                  <div class="col-lg-2 col-md-2 col-xs-2 padding0px">
                    <span><dx-button id="btnReview" (onClick)="btnReview_Click(oWarning)" text="Review" style="float: right;"></dx-button></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin: 0px; ">
        <div class="col-lg-12 col-md-12 col-xs-12 btn-section">
          <div class="col-lg-9 col-md-9 col-xs-9 padding0px" style="float: right;">
            <dx-button id="btnClose" (onClick)="btnClose_Click()" text="Close"></dx-button>
          </div>
        </div>
      </div>
    </div>

    <div class="popupWarning-header" *dxTemplate="let data of 'title'" style="padding:0px;">
      <p style="margin-left: 4px;margin-bottom: 4px;">
        <!--<i class="glyphicon glyphicon-alert" style="font-size:12px;color: #f1a100;"></i>-->
        <span>{{__sAlert}}</span>
      </p>
    </div>
  </dx-popup>

  <dx-popup class="popupSample"
            id="idPopupOverAllocation"
            [width]="650"
            [height]="'auto'"
            [showTitle]="true"
            title="Over Allocation"
            [dragEnabled]="false"
            [hideOnOutsideClick]="false"
            [visible]="__bOverAllocationAlertVisible || __bOverAllocationFocusOutAlertVisible" (visibleChange)="__bOverAllocationAlertVisible || (__bOverAllocationFocusOutAlertVisible = $event)">
    <div *dxTemplate="let data of 'content'">

      <div class="row message-border">
        <div class="col-lg-12 col-md-12 col-xs-12 message-box">
          <div id="form-limit">
            <div *ngIf="__bOverAllocationAlertVisible" class="col-lg-12 col-md-12 col-xs-12 padding0px" style="overflow-y: auto;height:110px;">
              <span class="fontStyle">
                <i class="glyphicon glyphicon-alert" style="font-size: 15px;color: #f1a100;">
                </i> The overall limit for this Counterparty is {{__oOverAllocation.OverallLimitValue.toLocaleString()}} {{__oOverAllocation.OverallLimitValueCurrencyName}}, it's over allocated by {{__oOverAllocation.MaxAllocation.toLocaleString()}} {{__oOverAllocation.MaxAllocationCurrencyName}}
              </span>
              <br />
              <br />
              <span class="fontStyle">To resolve the over allocation you will need to edit multiple limit values. Editing only this limit won't resolve the over allocation. </span>

            </div>

            <div *ngIf="__bOverAllocationFocusOutAlertVisible" class="col-lg-12 col-md-12 col-xs-12 padding0px" style="overflow-y: auto;height:110px;">
              <br />
              <span class="fontStyle">
                The overall limit for this Counterparty is {{__oOverAllocation.OverallLimitValue}},
                With {{__oOverAllocation.LimitValue}} sub limit you will be above the over all limit by {{__oOverAllocation.difference}}
              </span>
              <br />
            </div>

          </div>
        </div>
      </div>

      <div class="row" style="margin: 0px; ">
        <div class="col-lg-12 col-md-12 col-xs-12 btn-section">
          <div class="col-lg-9 col-md-9 col-xs-9 padding0px" style="float: right;">
            <dx-button id="btnClose" (onClick)="btnClose_Click()" text="Close"></dx-button>
          </div>
        </div>
      </div>

    </div>
  </dx-popup>


  <dx-popup [wrapperAttr]="{ class: 'popupSample' }"
            id="idAudit"
            [width]="700"
            [height]="'auto'"
            [showTitle]="true"
            [dragEnabled]="false"
            title="Audit Information"
            [hideOnOutsideClick]="true"
            [(visible)]="defaultVisible">
    <div *dxTemplate="let data = data of 'content'">

      <div class="row message-border" style="margin: 0.5rem">
        <div class="col-lg-12 col-md-12 col-xs-12 message-box">
          <div class="col-lg-12 col-md-12 col-xs-12 padding0px" style="border:1px solid;margin-bottom: 5px; background:white">
            <div class="col-lg-4 col-md-4 col-xs-4 padding0px text-center">
              <span style="font-weight:bold;">Status Information</span>
            </div>
            <div class="col-lg-4 col-md-4 col-xs-4 padding0px text-center">
              <span style="font-weight:bold;">User</span>
            </div>
            <div class="col-lg-4 col-md-4 col-xs-4 padding0px text-center">
              <span style="font-weight:bold;">Time stamp</span>
            </div>
          </div>

          <div class="col-lg-12 col-md-12 col-xs-12 padding0px" style="border:1px solid;">
            <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
              <div class="col-lg-4 col-md-4 col-xs-4 padding0px text-center">
                <span>Created by/on</span>
              </div>
              <div class="col-lg-4 col-md-4 col-xs-4 padding0px text-center">
                <span>{{__oAudit.Createdby}}</span>
              </div>
              <div class="col-lg-4 col-md-4 col-xs-4 padding0px text-center">
                <span>{{__oAudit.CreationTimeStamp}}</span>
              </div>
            </div>

            <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
              <div class="col-lg-4 col-md-4 col-xs-4 padding0px text-center">
                <span>Modified by/on</span>
              </div>
              <div class="col-lg-4 col-md-4 col-xs-4 padding0px text-center">
                <span>{{__oAudit.UserName}}</span>
              </div>
              <div class="col-lg-4 col-md-4 col-xs-4 padding0px text-center">
                <span>{{__oAudit.dteDateTime}}</span>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </dx-popup>

  <dx-popup class="popupInformation"
            id="popupValidations"
            [width]="800"
            [height]="'auto'"
            [showTitle]="true"
            titleTemplate="title"
            [dragEnabled]="false"
            [hideOnOutsideClick]="false"
            [(visible)]="__bValidationsVisible">
    <div *dxTemplate="let data of 'content'">

      <div class="row message-border">
        <div class="col-lg-12 col-md-12 col-xs-12 message-box">
          <div id="form-limit">
            <dx-scroll-view width="100%" height="100%">
              <div class="col-lg-12 col-md-12 col-xs-12 padding0px message-border" style="overflow-y: auto;height:19.375rem; padding: 1rem 0 0 1rem;margin: 0; ">
                <!--[title]="__sAlert"-->
                <div *ngFor="let oBreach of __oBreaches" style="display: flex;">

                  <div class="col-lg-9 col-md-9 col-xs-9 padding0px message-border" style="margin-top: 0.5rem; ">
                    <span>{{oBreach.sMessage}} </span><br /><br />
                  </div>
                  <div class="col-lg-2 col-md-2 col-xs-2 padding0px" style="margin-left: 0.625rem;">
                    <span style="padding: 1.5rem 1.5rem 5.0rem 1.5rem; "><dx-button id="btnReview" (onClick)="btnReview_Click(oBreach)" text="Review" style="float: right; width: 10rem; "></dx-button></span>
                  </div>
                </div>
              </div>
            </dx-scroll-view>
          </div>
        </div>
      </div>

      <div class="row" style="margin: 0px; ">
        <div class="col-lg-12 col-md-12 col-xs-12 btn-section">
          <div class="col-lg-9 col-md-9 col-xs-9 padding0px" style="float: right;">
            <dx-button id="btnClose" (onClick)="btnClose_Click()" text="Close"></dx-button>
          </div>
        </div>
      </div>

    </div>
    <div class="popupWarning-header" *dxTemplate="let data of 'title'" style="padding:0;">
      <p class="alert-popup-margin">
        <!--<i class="glyphicon glyphicon-alert" style="font-size:1.2rem;color: #f1a100;"></i>-->
        <span class="alert-popup-title">Alerts {{__oBreaches.length}}</span>
      </p>
    </div>
  </dx-popup>

  <dx-popup class="popupSample"
            id="popupLCPCGLimit"
            [width]="615"
            [height]="'auto'"
            [showTitle]="true"
            [title]="__sLinkLCsGuaranteesPopupTitle"
            [dragEnabled]="false"
            [hideOnOutsideClick]="false"
            [(visible)]="__bLCPCGVisible">
    <div *dxTemplate="let data of 'content'">

      <div class="row message-border">
        <div class="col-lg-12 col-md-12 col-xs-12 message-box">
          <div id="form-limit">
            <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
              <div class="dx-field">
                <div class="dx-field-label width-30">Link Overall Limit to:</div>
                <div class="dx-field-value padding-top-05rem">
                  <dx-check-box alignment="left" class="alginment_checkbox_icon" id="chkSetOverallLimit"
                                [(value)]="__oLCPCGLimit.IsEnabled">
                  </dx-check-box>
                </div>
              </div>

              <div class="dx-field padding-top-04rem">
                <div class="dx-field-value">
                  <dx-select-box id="cbOverallLimitSetting" [dataSource]="__oOverallLimitSettings"
                                 displayExpr="OverallLimitSettingName"
                                 valueExpr="OverallLimitSettingName"
                                 [(value)]="__oLCPCGLimit.OverallLimitSettingName"
                                 [disabled]="!__oLCPCGLimit.IsEnabled"
                                 [searchEnabled]="true">
                  </dx-select-box>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="row" style="margin: 0px; ">
        <div class="col-lg-12 col-md-12 col-xs-12 btn-section">
          <div class="col-lg-9 col-md-9 col-xs-9 padding0px" style="float: right;">
            <dx-button id="btnPopUpCancel" (onClick)="btnLCPCGCancel_Click()" text="Cancel"></dx-button>
            <dx-button id="btnOk" [disabled]="!__oLCPCGLimit.OverallLimitSettingName" (onClick)="btnLCPCG_Click()" text="Continue"></dx-button>

          </div>
        </div>
      </div>

    </div>
  </dx-popup>

  <dx-popup class="popupSample" id="popupPendingApproval" title="Pending approval" [(visible)]="__bPendingApprovalVisible"
            [width]="1000" [height]="'auto'" [showTitle]="true" [dragEnabled]="false" [hideOnOutsideClick]="false">
    <div *dxTemplate="let data of 'content'">
      <div class="worflow-container">
        <app-WorkflowDashBoard [__sURLBPI]='__iBPIId'
                               [__sURLBPDId]='__owfBusinessProcessDefinition.lwfBusinessProcessDefinitionId'
                               [__sURLBPS]='__owfBusinessProcessDefinition.lwfBusinessProcessStateId'
                               (__oOnClosePopup)="onCloseWorkflowPopup($event)">
        </app-WorkflowDashBoard>
      </div>
    </div>
  </dx-popup>

  <div *ngIf="__bValidationFailed" id="dvAlerts">
    <app-Alerts [__sMessageTitle]="__sMessageTitle" (__closeAlert)="onCloseAlert()" [__bConfirmationVisible]="__bConfirmationVisible" [__sMessage]="__sMessage" [__sMessageType]="__sMessageType"></app-Alerts>
  </div>
  <div *ngIf="__bCommentVisible" id="ppComments">
    <app-Comments [__oCounterpartyLimit]="__oCounterpartyLimit" (getCommentsCancelled)="getCommentsCancelledCallback($event)" (getCommentsUpdated)="getCommentsUpdatedCallback($event)" [__bCommentVisible]="__bCommentVisible"></app-Comments>
  </div>
  <div *ngIf="__bLimitCustomPropertyVisible" id="ppLimitCustomProperty">
    <app-limit-custom-property [__oCounterpartyLimit]="__oCounterpartyLimit" [__sPortalDateFormat]="__sPortalDateFormat" [__oLimitCustomProperties]="__oLimitCustomProperties" (getCustomPropertyUpdated)="getLimitCustomPropertyUpdatedCallback($event)" (getCustomPropertyCancelled)="getLimitCustomPropertyCancelledCallback($event)" [__bVisible]="__bLimitCustomPropertyVisible"></app-limit-custom-property>
  </div>
</div>

<app-confirmation [__iPopupHeight]="'auto'"></app-confirmation>


